UploadResults = new (function () {
  let wrapper;
  this.setSelects = () => {
    if (!wrapper || !wrapper.length) return;

    $("#result_subject", wrapper).select2({
      placeholder: "- Select -",
    });

    $("#uploads_result_title, #result_title", wrapper).select2({
      tags: true,
      placeholder: "Title (type and select from dropdown)",
    });

    $("#uploads_result_calendar_year", wrapper).select2({
      placeholder: "Academic Year",
      minimumResultsForSearch: Infinity,
    });

    $("#uploads_result_academic_year", wrapper).select2({
      placeholder: "Year group - at time of exam",
      minimumResultsForSearch: Infinity,
    });

    $("#r-calendar-year", wrapper).select2({
      placeholder: "- Select -",
      minimumResultsForSearch: Infinity,
    });

    $("#r-academic-year", wrapper).select2({
      placeholder: "- Select -",
      minimumResultsForSearch: Infinity,
    });

    $("#result_score_level", wrapper).select2({
      placeholder: "- Select -",
      minimumResultsForSearch: Infinity,
    });

    $("#r-student-select", wrapper).select2({
      placeholder: "- Select -",
      ajax: { dataType: "json", url: "/student_entities/autocomplete", delay: 250 },
    });
  };

  const dataYear = (calendar_year_parameter, title_parameter, calendar_parameter) => {
    let defaultDate = "";

    let year = calendar_year_parameter,
      yearMin = +year.val(),
      yearMax = yearMin + 1,
      calendar = calendar_parameter,
      valTitle = title_parameter.val();

    if (year.val() === "") {
      calendar.prop("disabled", true).val("");

      return false;
    }

    calendar.prop("disabled", false).val("");

    for (let option of title_parameter[0].options) {
      if (option.value === valTitle) {
        if (option.dataset.month) {
          defaultDate = `${option.dataset.day} ${option.dataset.month} ${option.dataset.month >= 8 ? yearMin : yearMax}`;
        }
        break;
      }
    }

    calendar.datepicker({
      appendText: "(dd-mm-yyyy)",
      defaultViewDate: "1 8 " + yearMin,
    });

    calendar
      .datepicker("setStartDate", "18 8 " + yearMin)
      .datepicker("setEndDate", "19 8 " + yearMax)
      .datepicker("setDate", defaultDate)
      .datepicker("refresh");
  };

  this.initForm = () => {
    wrapper = $(".upload_results_wrapper");
    if (!wrapper || !wrapper.length) return;
    Shared.applyFileValidation({
      fileSelector: "#uploads_result_file",
      submitSelector: ".upload_results_wrapper button[type='submit']",
    });

    // date year
    let bulk_calendar_year_identifier = $("#uploads_result_calendar_year", wrapper),
      bulk_title_identifier = $("#uploads_result_title", wrapper),
      bulk_calendar_identifier = $(".bulk-custom-calendar", wrapper),
      bulk_examined_at_identifier = $("#uploads_result_examined_at", wrapper),
      individual_calendar_year_identifier = $("#r-calendar-year", wrapper),
      individual_title_identifier = $("#result_title", wrapper),
      individual_calendar_identifier = $(".individual-custom-calendar", wrapper),
      individual_examined_at_identifier = $("#result_examined_at", wrapper);

    if (bulk_examined_at_identifier.length) {
      dataYear(bulk_calendar_year_identifier, bulk_title_identifier, bulk_calendar_identifier);
    }

    bulk_calendar_year_identifier.add(bulk_title_identifier).on("change", function () {
      dataYear(bulk_calendar_year_identifier, bulk_title_identifier, bulk_calendar_identifier);
    });

    if (individual_examined_at_identifier.length) {
      dataYear(individual_calendar_year_identifier, individual_title_identifier, individual_calendar_identifier);
    }

    individual_calendar_year_identifier.add(individual_title_identifier).on("change", function () {
      dataYear(individual_calendar_year_identifier, individual_title_identifier, individual_calendar_identifier);
    });
  };
})();
